import * as React from "react";
import { connect } from "react-redux";
import ToolTip from "@appComponents/ToolTip/ToolTip";

import IVerifyCertify from "./IVerifyCertify";
import { ITooltipMessages } from "../../interfaces/ITooltipMessages";

import { getTooltipMessages } from "./tooltipMessages";
import { TReducers } from "@features/reducers";

import * as style from "./VerifyCertifyStyle.module.scss";
import * as general from "@appStyles/general.module.scss";
import * as elements from "@appStyles/_elements.module.scss";

export const VerifyCertify: React.SFC<IVerifyCertify> = (props) => {
  const { investorData } = props;

  const tooltipMessages: ITooltipMessages = getTooltipMessages(
    investorData.organizational
  );

  return (
    <div className={[style.container, general.pX1].join(" ")}>
      <div className={style.innerWrapper}>
        <div className={[general.textCenter, general.mY2].join(" ")}>
          <h3 className={style.header}>Complete your investor status</h3>
          <h4 className={style.textStyle}>
            {" "}
            In order to continue, please complete your investor status.
          </h4>
        </div>
        <ul className={style.list}>
          <li className={style.listElement}>
            <div className={style.textStyle}>
              Verification status:{" "}
              <strong className={general.capitalize}>
                {investorData.verification_status}
              </strong>
              {!["verified", "fully_verified"].includes(
                investorData.verification_status
              ) && (
                <ToolTip
                  text={
                    tooltipMessages.verification[
                      investorData.verification_status
                    ]
                  }
                >
                  &nbsp; &#9432;
                </ToolTip>
              )}
            </div>
            {!["verified", "fully_verified"].includes(
              investorData.verification_status
            ) && (
              <a
                className={[
                  elements.btn,
                  elements.btnSuccess,
                  style.linkBtn,
                ].join(" ")}
                href={process.env.BF_IDENTITY_URL}
              >
                Verify Now
              </a>
            )}
          </li>
          <li className={style.listElement}>
            <div className={style.textStyle}>
              Certification status:
              <strong className={general.capitalize}>
                {" "}
                {investorData.certification_status.replace("_", " ")}
              </strong>
              {investorData.certification_status !== "certified" && (
                <ToolTip
                  text={
                    tooltipMessages.certification[
                      investorData.certification_status
                    ]
                  }
                >
                  &nbsp; &#9432;
                </ToolTip>
              )}
            </div>
            {investorData.certification_status !== "certified" && (
              <a
                className={[
                  elements.btn,
                  elements.btnSuccess,
                  style.linkBtn,
                ].join(" ")}
                href={process.env.BF_IDENTITY_URL}
              >
                Certify Now
              </a>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (store: TReducers) => {
  return {
    investorData: store.userInfo,
  };
};

export default connect(mapStateToProps)(VerifyCertify);
